export const CONSENT_KEY = 'rastyle_cookie_consent';
export const CONSENT_VERSION = '1.0';

export const readConsentPreferences = () => {
  if (typeof window === 'undefined') return null;
  try {
    const stored = JSON.parse(window.localStorage.getItem(CONSENT_KEY) || 'null');
    if (stored?.version !== CONSENT_VERSION) return null;
    return stored.preferences || null;
  } catch {
    return null;
  }
};

export const hasConsent = (category) => readConsentPreferences()?.[category] === true;
export const hasAnalyticsConsent = () => hasConsent('analytics');
export const hasMarketingConsent = () => hasConsent('marketing');
